<script setup>
import { ref, watch, onMounted } from "vue";
import { Modal } from "bootstrap";
import useCartStore from "../store/modules/cart";
import useEventListener from "../hooks/useEventListener";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";

translator.getLanguages();
const cartStore = useCartStore();

const props = defineProps({
	ticket: {
		type: Object,
		required: true,
	},
	isHistory: {
		type: Boolean,
		default: false,
	},
});

const extraInfo = ref();
const isShowPopUp = ref(false);
const myModalEl = ref(null);
const myModal = ref();

function showPopUp() {
	if (props.isHistory) {
		return;
	}

	isShowPopUp.value = true;
}

function fn() {
	cartStore.saveExtraInfo(props.ticket, extraInfo.value);
}
useEventListener(myModalEl, "hide.bs.modal", () => (isShowPopUp.value = false));
useEventListener(myModalEl, "show.bs.modal", () => (extraInfo.value = props.ticket.extraInfo));

onMounted(() => {
	myModal.value = new Modal(myModalEl.value);
	if (props.modelValue) myModal.value?.show();
});

watch(isShowPopUp, value => (value ? myModal.value.show() : myModal.value.hide()));
</script>

<template>
	<template v-if="!ticket.extraInfo">
		<div
			class="extra-info"
			:class="{ 'extra-info_active': !isHistory }"
			empty
			@click="showPopUp"
		>
			<svg height="15" width="15">
				<use xlink:href="#add"></use>
			</svg>
			<!-- eslint-disable-next-line -->
			<div v-html="ticket.extraInfoQuestion"></div>
		</div>
	</template>
	<template v-else>
		<div class="extra-info" :class="{ 'extra-info_active': !isHistory }" @click="showPopUp">
			<span class="extra-info__text">{{ ticket.extraInfo }}</span>
			<span v-if="!isHistory" class="extra-info__change">{{ translator.t('main', 'Edit')}}</span>
		</div>
	</template>

	<!-- PopUp -->
	<div ref="myModalEl" class="modal fade" tabindex="-1">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<button
					type="button"
					class="btn-close"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
				<div class="modal-header border-bottom-0 px-0 py-1">
					<div class="modal-title text-center">
						Укажите необходимые данные, чтобы купить парковочное место
					</div>
				</div>
				<div class="modal-body border-bottom-0 px-0 py-1">
					<input
						v-model="extraInfo"
						class="extra-info__input"
						placeholder="Регистрационный номер автомобиля N211CC"
					/>
				</div>
				<div class="modal-footer border-top-0 px-0 py-1">
					<button
						type="button"
						class="btn btn-success flex-grow-1"
						data-bs-dismiss="modal"
						:disabled="!extraInfo"
						@click="fn()"
					>
						{{translator.t('main', 'Next')}}
					</button>
				</div>
			</div>
		</div>
	</div>
	<!-- PopUp -->
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
.extra-info {
	display: flex;
	align-items: center;
	margin-top: 5px;

	&_active {
		cursor: pointer;
	}

	&[empty] {
		color: $error;
		div {
			display: inline-block;
		}
		svg {
			margin-right: 5px;
		}
	}
	&__text {
		max-width: 100px;
		margin-right: 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-weight: 500;
	}
	&__change {
		color: $success;
	}

	&__input {
		width: 100%;
		padding: 12px 0 12px 15px;
		border-radius: $border-radius;
		border: 1px solid $black;
		font-size: 14px;
		font-weight: 500;
		transition: .3s ease-in-out border-color;

		&::placeholder {
			color: $secondary;
			font-weight: 400;
		}

		&:focus {
			border-color: $primary;
		}
	}
}
.modal-content {
	padding: 50px 70px;
	position: relative;
	.btn-close {
		position: absolute;
		top: 10px;
		right: 10px;
	}
	.btn {
		background: $success;
		&:hover {
			color: #ffffff;
			border-color: $success;
		}
	}
	@media (max-width: $screen-small) {
		padding: 20px 20px;
		.btn-close {
			top: 5px;
			right: 5px;
		}
	}
}
</style>
